<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
  </div>
</template>
<script>
export default {
  name: "LimitsComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
};
</script>
